/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

function drawer_slider(){
  $('.cartdrawer_products').slick({
    dots: false,
    infinite: true,
    centerMode: true,
    speed: 300,
    slidesToShow: 2,
    slidesToScroll: 2,
    arrows:true    ,
    prevArrow: $('.prev'),
	nextArrow: $('.next'),
    responsive: [
      {
        breakpoint: 420,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },

    ],
  });  
}

$(document).on('click','.ad_to_cart_coll',function(){
  // console.log("yesss");    

  var ID = $(this).attr("data-var_id");
  get_id = ID;
  addItemToCart( ID, 1);    // paste your id product number
  $('.cart_dr').trigger( "click" );
});
function addItemToCart(variant_id, qty) {

  data = {
    "id": variant_id,
    "quantity": qty
  }
  jQuery.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: data,
    dataType: 'json',
    success: function(cart) { 
      //       $.ajax({
      //         type: 'GET',
      //         dataType: 'json',
      //         url: '/cart',
      //         success: function(cart){
      //          // console.log(cart.item_count);
      //         }
      //       });

      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true  //this code is for prestige theme, is to refresh the cart
      }));
      document.dispatchEvent(new CustomEvent('product:added', {
        bubbles: true,
        detail: {
          variant: variant_id,
          quantity: qty
        }
      }))
      jQuery.ajax({
        type: 'GET',
        url: '/cart.js',
        dataType: 'json',
        async:'true',   
        success: function(cartdata) {
          var count = cartdata['item_count'];
          setTimeout(function(){
            $('.cart_count').text(count);
          },2000);
        }
      });
      setTimeout(function(){
        drawer_slider();
      },2000);
    },
    error: function(XMLHttpRequest, textStatus, errorThrown) {
      console.log(get_id);
      $("span.ProductForm__Error.Alert--error.data-id"+get_id).show("slow").delay(1000).hide("slow");
      //       $(".eroor_message_for_cart").show("slow").delay(1000).hide("slow");

    }

  }); 

}
function cart_response(){
  jQuery.ajax({
    type: 'GET',
    url: '/cart.js',
    dataType: 'json',
    async:'true',   
    success: function(cartdata) {
      var count = cartdata['item_count'];

      $('.cart_count').text(count);

    }
  });
}
$(document).ready(function() {
  // about us page
  $(".About-us li.FaqSummary__Item").on("click",function(){
    $(".About-us li.FaqSummary__Item").removeClass("is-active");
    $(this).addClass("is-active");
  });
  // Tabs height calculate
  var heighttabs = $(".Product__Aside.metafields").height();
  $(".Product__Gallery").css("margin-bottom",heighttabs);

  $("button.Collapsible__Button.Heading").on("click",function(){
    const myTimeout = setTimeout(height_tabs, 300);
    function height_tabs() {
      var heighttabs = $(".Product__Aside.metafields").height();
      $(".Product__Gallery").css("margin-bottom",heighttabs);
    };
  });




  $(function () {
    setTimeout(function(){
      cart_response();
    },2000);
    // create new variable for each menu
    var dd1 = new DropDown($('#custom-drop-down'));
    // var dd2 = new DropDown($('#other-gases'));
    $(document).click(function () {
      // close menu on document click
      $('.wrap-drop').removeClass('active');

     // $(".wrap_variant_selected_text span").hide();
      const myTimeout = setTimeout(variant_show, 10);
      function variant_show() {
        // metavaluetext
        var get_selectvar_id =   $("select.selected_form option:selected").val();
        $("span.metafields_text"+get_selectvar_id).show();
        //console.log(get_selectvar_id);
        //variant_title
        var variant_selected =  $("li.HorizontalList__Item input:checked").val();
        $(".ProductMeta h6.ProductMeta__variant.u-h6.Text--subdued").text(variant_selected);
        //console.log(variant_selected);
      }

    });

    $(document).on("click",".accordion_head",function () {
      if ($('.accordion_body').is(':visible')) {
        $(".accordion_body").slideUp(300);
        $(".plusminus").text('+');
      }
      if ($(this).next(".accordion_body").is(':visible')) {
        $(this).next(".accordion_body").slideUp(300);
        $(this).children(".plusminus").text('+');
      } else {
        $(this).next(".accordion_body").slideDown(300);
        $(this).children(".plusminus").text('-');
      }
    });

  });





});

//  about us page on scroll active tittle

$(document).on('click','.QuantitySelector__Button, .CartItem__Remove',function(){
  setTimeout(function(){
    cart_response();
    drawer_slider()
  },2000);
});

$(document).on('change','.QuantitySelector__CurrentQuantity',function(){
  setTimeout(function(){
    cart_response();
    drawer_slider()
  },2000);
});

$.fn.isInViewport = function() {

  var elementTop = $(this).offset().top;

  var elementBottom = elementTop + $(this).outerHeight() / 2;

  var viewportTop = $(window).scrollTop();

  var viewportHalf = viewportTop + $(window).height() / 2;

  return elementBottom > viewportTop && elementTop < viewportHalf;

};

// 

$(".for-mobile-li").click(function(){
  var curr =$(this).attr("data-link");
  $(".HorizontalList__Item[data-link='"+curr+"'] input").trigger("click");
});

$(document).ready(function() {
  var curr = $(".HorizontalList__Item input:checked").parent().attr("data-link");
  $(".for-mobile-li[data-link='"+curr+"']").trigger("click");
  $(".for-mobile-li[data-link='"+curr+"']").addClass('selected');
  var loadValue = $(".for-mobile-li.selected").text();
  $(".wrap-drop span").text(loadValue)

});

// Inspiration: https://tympanus.net/codrops/2012/10/04/custom-drop-down-list-styling/


function DropDown(el) {
  this.dd = el;
  this.placeholder = this.dd.children('span');
  this.opts = this.dd.find('ul.drop li');
  this.val = '';
  this.index = -1;
  this.initEvents();
}

DropDown.prototype = {
  initEvents: function () {
    var obj = this;
    obj.dd.on('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      $(this).toggleClass('active');
    });
    obj.opts.on('click', function () {
      var opt = $(this);
      obj.val = opt.text();
      obj.index = opt.index();
      obj.placeholder.text(obj.val);
      opt.siblings().removeClass('selected');
      opt.filter(':contains("' + obj.val + '")').addClass('selected');
      obj.dd.toggleClass('active');
    }).change();
  },
  getValue: function () {
    return this.val;
  },
  getIndex: function () {
    return this.index;
  }
};

$(window).on('load',function(){
  setTimeout(function(){
    drawer_slider();
  },2000);
});

$(window).on('resize scroll', function() {

  $('.Anchor').each(function() {


    if ($(this).isInViewport()) {
      $(this).addClass("in-view");
      var currentId = $(this).attr("id");
      var ids ='#'+currentId;  
      $(".FaqSummary__Item").removeClass("is-active"); 
      $(".FaqSummary__Link[href='"+ids+"']").parent().addClass("is-active");
    } else {

      $(this).removeClass("in-view");

    }

  });


});
//  about us page on scroll active tittle



$(document).on('click','.cartdrawer_products .ad_to_cart_coll',function(e){
  // console.log("yesss");    
  e.preventDefault(0);
  var ID = $(this).attr("data-var_id");
  get_id = ID;
  addItemToCart( ID, 1);    // paste your id product number
  setTimeout(function(){
    drawer_slider();
  },2000);
});

$('.ProductForm__AddToCart').click(function(){
	 setTimeout(function(){
    drawer_slider();
  },2000);
});
$(".custom_search").click(function(){
$("button.Drawer__Close.Icon-Wrapper--clickable").trigger('click');
    
});


$(document).ready(function() {
  $(window).scroll(function() {
    if ($(document).scrollTop() > 42) {
      $(".Header__Wrapper").addClass("scroll-header");
    } else {
      $(".Header__Wrapper").removeClass("scroll-header");
    }
  });

  $("li.HorizontalList__Item").hover(
  function () {
    $(this).parents( "header" ).addClass("bg_header");
  },
  function () {
    $(this).parents( "header" ).removeClass("bg_header");
  }
);
  
});



